import React, { useState, useEffect } from 'react';
import styles from './AdminMobileSortToggleBtn.module.css';
import P from 'components/P';
import Center from 'layouts/wrapper/Center';

const AdminMobileSortToggleBtn = ({ onChange, order }) => {
    const [localOrder, setLocalOrder] = useState(order); // order 값을 localOrder 상태로 관리

    useEffect(() => {
        setLocalOrder(order); // order 값이 변경될 때마다 localOrder를 업데이트
    }, [order]);

    const handleClick = () => {
        const newOrder = localOrder === 'asc' ? 'desc' : 'asc'; // 토글
        setLocalOrder(newOrder); // 상태 업데이트
        onChange(newOrder); // 변경된 순서 전달
    };

    

    return (
        <div className={styles.btn} onClick={handleClick}>
            <Center>
                <P size={"max(1vw, 15px)"}>{localOrder === 'asc' ? '과거 기준' : '최신 기준'} {/* 상태에 따라 텍스트 변경 */}</P>
            </Center>
        </div>
    );
};

export default AdminMobileSortToggleBtn;